<ng-container *ngIf="show">
    <!-- this button's id is used in upload-dialog.component.ts to focus back on this button after the user closes the dialog -->
    <button id="upload-button"
            [ngClass]="{'generic-button generic-button--fluent generic-button--fluent--secondary ms-bgc-w ms-bgc-tp-h ms-bgc-tp-a ms-fcl-tp ms-fcl-w-h ms-fcl-w-a': !showAsLink,
                    'upload-link ms-fcl-tda ms-fcl-tda-h ms-fcl-tdr-f ms-fcl-tdr-a' : showAsLink}"
            (click)="selectFile()"
            title="{{showAsLink ? title : ''}}"
            [attr.aria-label]="ariaLabel"
            [ohpInstrumentClick]="clickData"
            #uploadButton>
        <ohp-icon-font [iconFontType]="icon"
                       size="16"
                       [cssClass]="'upload-button__icon' + (showAsLink ? ' upload-link__icon' : '')"></ohp-icon-font>
        <span [ngClass]="{'generic-button__text': !showAsLink,
                        'upload-link__text ms-u-hiddenLgDown': showAsLink}">{{ title }}</span>
    </button>
</ng-container>
